import { useState, useEffect, memo } from "react";
import { Box, Flex, Image } from "@chakra-ui/react";

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import LaunchdeckButton from "../../global/components/helper-components/components/LaunchdeckButton";
import useLaunchdeckModal from "../../global/hooks/use-launchdeck-modal";

function DsrManageOrgLogosModule({
  logoDisplayMode,
  isPagePreviewMode,
  dsrDisplayLogoImages,
  dsrStatusRedux,
  dsrTextLogoString,
  isLiveEdit,
  logoSize,
  // Redux
  isPublicDsrEnvironment,
  isArchivedDsr,
}) {

  const [isPublishedDsr, setIsPublishedDsr] = useState("")
  const [showAudienceLogo, setShowAudienceLogo]= useState(true)
  const [showHostLogo, setShowHostLogo]= useState(true)
  
  const { openLaunchdeckModal } = useLaunchdeckModal();

  useEffect(() => {
    if (dsrStatusRedux === 'active') {
      setIsPublishedDsr(true)
    } else setIsPublishedDsr(false)
  }, [dsrStatusRedux])


  const {
    displayedAudienceLogo,
    displayedHostLogo,
    displayedHostOrgName,
    hideDisplayLogoModule,
    foundAudienceOrgLogo,
    noGuestLogo 
  } = dsrDisplayLogoImages || {};
  
  const handleOpenEditLogoModal = () => {
    if (!isPublishedDsr || !isArchivedDsr || isLiveEdit) {
      openLaunchdeckModal('manage-dsr-audience-logo')
    }
  }

  const uploadAudienceLogo = () => {
    if (isArchivedDsr) return null;
    else return (
      <Flex align='center' ml='1em'>
        <LaunchdeckButton bg='#29ABE21A' color='#29ABE2' fontSize='0.8em' onClick={() => handleOpenEditLogoModal()} label='Add Guest logo' />
      </Flex>
    )
  }

  const renderNametagLogo = () => {
    if (displayedHostLogo) {
      return (
        <Box border='2px solid' borderColor='white' rounded='0.5em' bg='white'>
          <Image maxH={'3.5em'} rounded='0.25em' src={displayedHostLogo} />
        </Box>
      ) 
    }
  }

  const renderLogoImage = (team) => {
    if (team === 'host' && displayedHostLogo) {
      if (showHostLogo) {
        return (
          <Box border='2px solid' borderColor='white' rounded='0.5em' bg='white'>
            <Image maxH={logoSize ? logoSize : '2.5em'} rounded='0.25em' src={displayedHostLogo} onError={() => setShowHostLogo(false)}/>
          </Box>
        )
      } else return null;
      
    } else if (team === 'audience') {
      if ((!!isPublishedDsr || !!isPagePreviewMode) && (!isLiveEdit && !!noGuestLogo)) {
        return null
      } 

      if (dsrTextLogoString && !displayedAudienceLogo) {
        return (
          <Flex align='center' mr='0.5em'>
            <Box p='0.5em' border='1px solid' borderColor='gray.200' rounded='0.5em' bg='white'>
              {dsrTextLogoString}
            </Box>
          </Flex>
        )
      } else if (displayedAudienceLogo) {
        if (showAudienceLogo) {
          return (
            <Flex align='center'>
              <Box border='2px solid' borderColor='white' rounded='0.5em' bg='white'>
                <Image maxH={logoSize ? logoSize : '2.5em'} rounded='0.25em' src={displayedAudienceLogo} onError={() => setShowAudienceLogo(false)}/>
             </Box>
            </Flex>
          )
        } else return null;
       
      } else if (foundAudienceOrgLogo) {
        if (showAudienceLogo) {
          return (
            <Flex align='center'>
              <Box border='2px solid' borderColor='white' rounded='0.5em' bg='white'>
              <Image maxH={'2.5em'} rounded='0.25em' src={foundAudienceOrgLogo} onError={() => setShowAudienceLogo(false)}/>
            </Box>
            </Flex>
          )
        } else return null
      } else {
        if ((isPublishedDsr === true && !isLiveEdit) || isPagePreviewMode === true) {
          return null
        } else {
          return uploadAudienceLogo()
        }

      }

    } else return null;
  }

  if (!hideDisplayLogoModule) {
    switch (logoDisplayMode) {
      case ('default-dsr'): {
        // This is the default case
        return (
          <Box>
            <Flex w='100%' align='center' justify='center' gap='0.8em'>
              {renderLogoImage('host')}
        
              <Box cursor={((isPublishedDsr && !isLiveEdit) || isPublicDsrEnvironment || isPagePreviewMode || isArchivedDsr) ? 'default' : 'pointer'} onClick={() => ((isPublishedDsr && !isLiveEdit) || isPublicDsrEnvironment || isPagePreviewMode || isArchivedDsr) ? null : handleOpenEditLogoModal()}>
                {renderLogoImage('audience')}
              </Box>
              
            </Flex>
          </Box>
        )
      }
      case ('dsr-template'):
      case ('prospect-dsr'): {
        return (
          <Box p='1em'>
          <Flex w='100%' align='center' justify='center'>
            {renderLogoImage('host')}
          </Flex>
        </Box>
        )
      }
      case('nametag'): {
        return (
          <Flex justify='flex-start' align='center' gap={4} border='1px solid' borderColor='gray.100' rounded='0.5em' bg='white'
          // my='1em'
          >
            {renderNametagLogo('host')}
            {displayedHostOrgName && <Box maxW='25em' pr='1em'>
              <Box fontSize='0.875em' color='brandDark.500' fontWeight='600'>{displayedHostOrgName}</Box>
            </Box>}
          </Flex>
        )
      }
      default: {
        return null;
      }
    }
  } else return null;
}

const mapStateToProps = (state) => ({
  dsrStatusRedux: state.dsrStatus.status,
  dsrDisplayLogoImages: state.dsrDisplayLogoImages.dsrDisplayLogos,
  dsrTextLogoString: state.draftDsrProperties.properties.dsrTextLogoString,
  isPublicDsrEnvironment: state.publicDsrEnvironment.publicDsrEnv,
  isArchivedDsr: state.isArchivedDsr.results
})

export default memo(withRouter(connect(mapStateToProps, null)(DsrManageOrgLogosModule)))
